import lodash from 'lodash';

// TODO: should be imported from the monorepo, but it is not currently exported
export const customParamsSerializer = (params: Record<string, unknown> | URLSearchParams): string => {
  if (params instanceof URLSearchParams) return params.toString();

  const parts: string[] = [];

  for (const [key, val] of Object.entries(params)) {
    if (val === null || typeof val === 'undefined') {
      continue;
    }
    const arrayValue: unknown[] = lodash.isArray(val) ? val : [val];

    for (let value of arrayValue) {
      if (lodash.isDate(value)) {
        value = value.toISOString();
      } else if (lodash.isObject(value)) {
        value = JSON.stringify(value);
      }
      parts.push(encode(key) + '=' + encode(value as string));
    }
  }

  return parts.join('&');
};

const encode = (val: string): string => {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
};
